import styled from 'styled-components';
import ReactEmptyState from '@jswork/react-empty-state';
import ImageIcon from 'common/components/ImageIcon';
import { Button, Icon } from 'antd';

const Container = styled.div`
  width: 100%;
  height: 600px;
  position: relative;
  .anticon {
    color: #fff;
  }
`;

export default () => {
  const { canEdit } = nx.$root.content;
  return (
    <Container data-disabled={!canEdit}>
      <ReactEmptyState
        centered={true}
        element={<ImageIcon value={'ic_video_grey@2x'} size={{ width: 121, height: 86 }} />}
        title={
          <View mt={27} mb={37} tc={true} f={14}>
            请将Video课件文档文件拖拽到这里或者点击上传 <br />
            支持格式：mp4
          </View>
        }>
        <Button type="primary">
          <Icon type="plus" />
          上传视频
        </Button>
      </ReactEmptyState>
    </Container>
  );
};
